/**
 * Follow-ups carry their lead (paging 3/4): GET /follow-ups returns each row
 * with `lead` — job number, name and the client columns. The screens that list
 * follow-ups used to load every lead to label them, and that list stopped at
 * 1,000 rows. This builds the same lead_id -> lead map from the follow-ups
 * themselves.
 */
export function leadsOfFollowUps(followUps: any[] | null | undefined): Map<string, any> {
  const map = new Map<string, any>();
  for (const f of followUps ?? []) if (f?.lead && f.lead_id) map.set(String(f.lead_id), f.lead);
  return map;
}
